import React from "react";
import NbaLogo from "../../assets/nba_logo.png";
import {  Box, Typography } from "@mui/material";
import "./nav_bar.styles.css";
import { Link } from "react-router-dom";
function NavBar() {
  return (
    <div className="navbar">
      <Box display="flex" alignItems="center" margin="auto" gap="1rem">
        <Link to="/">
        <Box
            sx={{
              height:"80px",
              width:"86px",
              // border:"1px solid red",
              backgroundImage:`url(${NbaLogo})`,
              backgroundSize:"100% 100%",
              backgroundPosition:"center",
              backgroundRepeat:"no-repeat",
              // border:"1px solid yellow"
            }}
          >

          </Box>
        </Link>
        <Link to="/" style={{ textDecoration: "none" }}>
          <Typography component="h3" 
            sx={{
              fontFamily:"Roboto-serif",
              fontWeight:"600",
              fontSize:"24px"
            }}
          >Nepal Badminton Association(NBA)</Typography>
        </Link>
      </Box>
      {/* {isAuthenticated && (
        <Box>
          <Button
            variant="contained"
            onClick={handleLogout}
            size="small"
            endIcon={<LogoutIcon fontSize="string" />}
            sx={{
              padding: { md: "4px 16px", xs: "4px 8px" },
              backgroundColor: "#A91720",
              "&:hover": {
                backgroundColor: "#8f141c",
              },
            }}
          >
            <Typography sx={{ fontSize: { md: "14px", xs: "10px" } }}>
              Logout
            </Typography>
          </Button>
        </Box>
      )} */}
    </div>
  );
}

export default NavBar;
